import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useRolePermissions } from '@/hooks/use-role-permissions';
import { Badge } from '@/components/ui/badge';

export default function PaymentsTestsPage() {
  const { canView, canManage, user } = useRolePermissions();
  const view = canView('payments');
  const edit = canManage('payments');

  return (
    <div className="p-4 md:p-6 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Payments UI Diagnostics</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-sm text-muted-foreground">Signed-in user:</div>
          <div className="text-sm">ID: {user?.id ?? 'N/A'}</div>
          <div className="text-sm">Role: {user?.role ?? 'N/A'}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div className="space-y-1">
              <div className="text-sm text-muted-foreground">View permission (payments:view)</div>
              <Badge variant={view ? 'default' : 'destructive'}>{view ? 'PASS' : 'FAIL'}</Badge>
            </div>
            <div className="space-y-1">
              <div className="text-sm text-muted-foreground">Edit permission (payments:edit)</div>
              <Badge variant={edit ? 'default' : 'destructive'}>{edit ? 'PASS' : 'FAIL'}</Badge>
            </div>
          </div>
          <div className="text-sm mt-4">
            This page verifies RBAC gating used by Transactions and Details pages without calling the backend.
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Manual Integration Checklist</CardTitle>
        </CardHeader>
        <CardContent className="text-sm space-y-2">
          <ol className="list-decimal pl-5 space-y-1">
            <li>Open /payments/transactions and verify filters work and pagination updates.</li>
            <li>Open a transaction details page and test: Capture (authorized), Cancel (pending/authorized), Refund (paid), Reconcile (any).</li>
            <li>Confirm action responses show structured payload and transaction status updates.</li>
            <li>Visit /payments/logs and confirm filtering, pagination, and expandable JSON.</li>
          </ol>
        </CardContent>
      </Card>
    </div>
  );
}


